module.exports = __webpack_public_path__ + "img/judge.f590da94.png";